module.exports = __webpack_public_path__ + "img/logo-alt.9f8644b.png";